import {
  addServiceRecordFail,
  addServiceRecordSuccess,
  deleteServiceRecordFail,
  deleteServiceRecordSuccess,
  serviceRecordById,
  getServiceRecordFail,
  getServiceRecordSuccess,
  serviceRecordAddFileFail,
  serviceRecordAddFileSuccess,
  serviceRecordByIdFail,
  serviceRecordByIdSuccess,
  serviceRecordDeleteFileFail,
  serviceRecordDeleteFileSuccess,
  updateServiceRecordFail,
  updateServiceRecordSuccess,
  getServiceLogsSuccess,
  getServiceLogsFail,
} from "./action";
import {
  ADD_SERVICE_RECORD,
  DELETE_SERVICE_RECORD,
  GET_SERVICE_RECORDS,
  GET_SERVICE_RECORD_LOGS,
  SERVICE_RECORDS_BY_ID,
  SERVICE_RECORD_ADD_FILE,
  SERVICE_RECORD_DELETE_FILE,
  UPDATE_SERVICE_RECORD,
} from "./actionType";
import {
  onGetServiceList,
  onAddingServiceRecord,
  onDeletingServiceRecord,
  onUpdatingServiceRecord,
  onGetServiceListDetails,
  onAddServiceRecordFile,
  onDelServiceRecordFile,
  onGettingServiceLogs,
} from "helpers/fakebackend_helper";
import { call, put, takeEvery } from "redux-saga/effects";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";
const toastTitle = "Service Record";

function* onAddingFiles({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddServiceRecordFile, data);
    yield call(responseHandler, toastTitle, response, serviceRecordAddFileSuccess, serviceRecordAddFileFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(serviceRecordAddFileFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onDeletingFileServiceRecord({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDelServiceRecordFile, data);
    yield call(responseHandler, toastTitle, response, serviceRecordAddFileSuccess, serviceRecordDeleteFileFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(serviceRecordDeleteFileFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetingServiceRecordDetails({ payload: data }) {
  try {
    const response = yield call(onGetServiceListDetails, data);
    if (response.status) {
      yield put(serviceRecordByIdSuccess(response));
    } else {
      yield put(serviceRecordByIdFail(response));
      showToast("warning", toastTitle, response.message);
    }
  } catch (error) {
    yield put(serviceRecordByIdFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetingServiceRecord({ payload: data }) {
  try {
    const response = yield call(onGetServiceList, data);
    if (response.status) {
      yield put(getServiceRecordSuccess(response));
    } else {
      yield put(getServiceRecordFail(response));
      showToast("warning", toastTitle, response.message);
    }
  } catch (error) {
    yield put(getServiceRecordFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onAddServiceRecord({ payload: data }) {
  try {
    const response = yield call(onAddingServiceRecord, data);
    if (response.status) {
      yield put(addServiceRecordSuccess(response));
      showToast("success", toastTitle, response.message);
    } else {
      yield put(addServiceRecordFail(response));
      showToast("warning", toastTitle, response.message);
    }
  } catch (error) {
    yield put(addServiceRecordFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onUpdateServiceRecord({ payload: data }) {
  try {
    const response = yield call(onUpdatingServiceRecord, data);
    if (response.status) {
      yield put(updateServiceRecordSuccess(response));
      showToast("success", toastTitle, response.message);
      // setTimeout(() => showToast("info", "Update Vehicle Service", "Please update the next service details of this vehicle", 7000), 200)
    } else {
      yield put(updateServiceRecordFail(response));
      showToast("warning", toastTitle, response.message);
    }
  } catch (error) {
    yield put(updateServiceRecordFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onDeleteServiceRecord({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingServiceRecord, data);
    // if (response.status) {
    //     yield put(deleteServiceRecordSuccess(response))
    //     showToast("success", toastTitle, response.message)
    // } else {
    //     yield put(deleteServiceRecordFail(response))
    //     showToast("warning", toastTitle, response.message)
    // }
    yield call(responseHandler, toastTitle, response, deleteServiceRecordSuccess, deleteServiceRecordFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteServiceRecordFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetServiceLogs({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingServiceLogs, data);
    yield call(responseHandler, toastTitle, response, getServiceLogsSuccess, getServiceLogsFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getServiceLogsFail(error));
    showToast("error", toastTitle, error);
  }
}

function* ServiceRecordSaga() {
  yield takeEvery(GET_SERVICE_RECORDS, onGetingServiceRecord);
  yield takeEvery(ADD_SERVICE_RECORD, onAddServiceRecord);
  yield takeEvery(DELETE_SERVICE_RECORD, onDeleteServiceRecord);
  yield takeEvery(UPDATE_SERVICE_RECORD, onUpdateServiceRecord);
  yield takeEvery(SERVICE_RECORDS_BY_ID, onGetingServiceRecordDetails);
  yield takeEvery(SERVICE_RECORD_ADD_FILE, onAddingFiles);
  yield takeEvery(SERVICE_RECORD_DELETE_FILE, onDeletingFileServiceRecord);
  yield takeEvery(GET_SERVICE_RECORD_LOGS, onGetServiceLogs);
}

export default ServiceRecordSaga;
